export default {
  get(state) {
    console.log("get securepay response", state.data);
    return state.data;
  },
  paymentType(state, getters) {
    const response = getters["get"];
    if ("cardtype" in response && typeof response["cardtype"] === "string") {
      return response["cardtype"].toLowerCase();
    }
    return "";
  },
  altpayType(state, getters) {
    const response = getters["get"];
    if ("altpayType" in response && typeof response["altpayType"] === "string") {
      return response["altpayType"].toUpperCase();
    }
    return "";
  },
};
